var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 15.1666C9.84061 15.1666 11.5073 14.4204 12.7137 13.214C13.9201 12.0075 14.6663 10.3409 14.6663 8.49992C14.6663 6.65899 13.9201 4.99232 12.7137 3.78587C11.5073 2.57945 9.84061 1.83325 7.99967 1.83325C6.15874 1.83325 4.49207 2.57945 3.28563 3.78587C2.0792 4.99232 1.33301 6.65899 1.33301 8.49992C1.33301 10.3409 2.0792 12.0075 3.28563 13.214C4.49207 14.4204 6.15874 15.1666 7.99967 15.1666Z",
    stroke: "#215AA8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.0416V8.70825C9.10457 8.70825 10 7.81282 10 6.70825C10 5.60369 9.10457 4.70825 8 4.70825C6.89543 4.70825 6 5.60369 6 6.70825",
    stroke: "#215AA8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08366 12.2083C8.08366 12.2544 8.04634 12.2917 8.00033 12.2917C7.95431 12.2917 7.91699 12.2544 7.91699 12.2083C7.91699 12.1623 7.95431 12.125 8.00033 12.125C8.04634 12.125 8.08366 12.1623 8.08366 12.2083Z",
    fill: "#215AA8",
    stroke: "#215AA8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBlue);
export default __webpack_public_path__ + "static/media/question-blue.be204e5ff70dd8c61e2f0d2ec6e1603f.svg";
export { ForwardRef as ReactComponent };